import { render } from "./SideProjects.vue?vue&type=template&id=719d0cc4&scoped=true"
import script from "./SideProjects.vue?vue&type=script&lang=js"
export * from "./SideProjects.vue?vue&type=script&lang=js"

import "./SideProjects.vue?vue&type=style&index=0&id=719d0cc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719d0cc4"]])

export default __exports__